import { Component, OnInit ,HostListener} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { Subscription } from 'rxjs';
import { getLocalJSON, isValidStored } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  subscription =<any> Subscription;
  public loginTrue:boolean= false;
  public loginDetail:any =[];
  public urlTrue:boolean = false;
  public NotificationDetail : any =[];
  public dataCount : any =1;
  public noti_length :any = 0;
  public pagecount: any = 1;
  public UnreadCount : any=0;
  public loginImage:any='';
  public search:any='';
  public viewClose:boolean=false


  constructor(public router: Router, public service: GlobalService) {
    
    if(localStorage.getItem('grw_serachText')){
      this.search = localStorage.getItem('grw_serachText');
      this.viewClose=true;
    }
    if(isValidStored('grw_login')){
      this.subscription = this.service.getSubject().subscribe((message:any)=>{
        this.loginDetail=message.loginData;
        if(this.loginDetail.profile_image ==''){
          this.loginImage ='../../../assets/images/avatar-1.png';
        } else {
          this.loginImage = this.loginDetail.profile_image;
        }
      })
      this.loginTrue = true;
      this.loginDetail = getLocalJSON('grw_login');
      if(this.loginDetail.profile_image ==''){
        this.loginImage ='../../../assets/images/avatar-1.png';
      } else {
        this.loginImage = this.loginDetail.profile_image;
      }
      this.getNotifiction(); 
    }
    this.sideIcon(true);
    }

    @HostListener('wheel', ['$event']) onMouseWheel(event: WheelEvent) {
      this.onScroll();
    }
  
   ngOnInit(): void {
    if(localStorage.getItem('grw_serchView')){
      var mm :any =localStorage.getItem('grw_serchView');
      if(mm==1){
        this.urlTrue = true;
      } else {
        this.urlTrue = false;
      }      
    }
   }

   getNotifiction(){
    var detail ={"page":this.pagecount};
    var url = '/notification';
    this.service.PostApis(detail,url).subscribe(((response : any) => {
      if(response.success==1){ 
        if(response.data.records.length!=0){
          response.data.records.filter((el:any)=>{
            var date= this.service.dateCon(el.createdAt);
            var time = this.service.dateTImeCon(el.createdAt);
            var ss=new Date(date + ' '+time);            
            el.create_dt_utc_new = this.service.timeago(new Date(ss.getTime() - ss.getTimezoneOffset() * 60000));
            if(el.is_read == false){
              el.class="unread";
            }
          })
        }
        // if(response.data.records.length!=0){
        //   const data = response.data.records; 
        //   for(let i=0;i<data.length;i++)  {
        //     data[i].create_dt_utc_new = this.service.dateConvert(data[i].created_at,5);
        //     if(data[i].is_read == false){
        //       data[i].class="unread";
        //     }
        //   }
        // }
        if(this.pagecount == 1){
          this.NotificationDetail = response.data.records;
        } else {
          this.NotificationDetail =this.NotificationDetail.concat(response.data.records);
        }
        this.noti_length = response.data.records.length;
        this.UnreadCount = response.data.unreadCount;
      } else{
        this.dataCount = 0;
      }
    }))
  }

  getMarkRead(data :any){
    if(data.is_read == false){
      this.markRead(data._id);
    }
  }

//onScroll function for scroll listing..of the event,...
  onScroll() {
    if(this.dataCount!=0 && this.noti_length == 10) {
      this.pagecount++;
      this.getNotifiction();
    }
  }

  markRead(id:any){
    var detail ={ "notification_id":id};
    var url =  '/notification-read';
    this.service.PostApis(detail,url).subscribe(((response : any) => {
      if(response.success==1){
        this.pagecount = 1;
        this.getNotifiction();  
      } else{
      }
    }))
  }

  close(){
    $('#CONFIRMPopup1').modal('toggle');
  }

  searchText(type:any){
    if(type==1){
      this.viewClose=true;
      localStorage.setItem('grw_serachText',this.search);
      this.router.navigate(['/search']);  
    } else {
      this.viewClose= false;
      this.search='';
      localStorage.removeItem('grw_serachText');
      this.router.navigate(['/dashboard']);  

    }
  }

  sideIcon(firstLogin = false) {
    if (localStorage.getItem('sidebar_selection')) {
      const sidebar_selection = localStorage.getItem('sidebar_selection');
      if (firstLogin) {
        if (sidebar_selection == '1') {
          $('.main-site-wrap').addClass('toggled');
        }
      } else {
        if (sidebar_selection == '1') {
          $('.main-site-wrap').removeClass('toggled').removeClass('sidebar-hovered');
          localStorage.setItem('sidebar_selection', '0');
        } else {
          $('.main-site-wrap').addClass('toggled');
          localStorage.setItem('sidebar_selection', '1');
        }  
      }      
    } else {
      $('.main-site-wrap').addClass('toggled');
      localStorage.setItem('sidebar_selection', '1');
    }
  }
}
